import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedPrLineUnitPriceLineFragmentDoc = gql`
  fragment AdvancedPrLineUnitPriceLine on RequisitionLine {
    id
    uuid
    unitPrice
    taxPercentage
    quantity
    product {
      id
    }
    supplier {
      id
    }
    availableQuotes {
      unitPrice
      taxPercentage
      ...ActiveSupplierQuote
    }
  }
  ${ActiveSupplierQuoteFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedPrLineUnitPriceLineFragment, unknown>
